// Swiper js with thumb slider 
class BzSlider extends HTMLElement {
  constructor() {
    super();

    let optionsData = {};
    let defaults = {};
    let autoplay = false;
    this.swiperInstance = null;
    this.buildTimelineSource();
    this.buildShowcaseSource();
    this.buildInfoTabSource();

    if (this.dataset.sectionSetting || this.dataset.blockSetting) {
      const sectionSetting = JSON.parse(this.dataset.sectionSetting);
      const space = +this.dataset.spacingGridHorizontal;
      const spacemobile = space / 2;

      optionsData = {
        slidesPerView: sectionSetting.columns_desktop || 1,
        spaceBetween: space,
        loop: false,
        speed: 700,
        dragClickables: false,
        updateOnWindowResize: true,
        pagination: {
          clickable: true,
        },
        breakpoints: {
          0: {
            slidesPerView: sectionSetting.columns_mobile || 1,
            spaceBetween: spacemobile,
          },
          768: {
            slidesPerView: sectionSetting.columns_desktop || 1,
            spaceBetween: space,
          },
          992: {
            slidesPerView: sectionSetting.columns_desktop || 1,
            spaceBetween: space,
          },
        },
      };

      if (sectionSetting.center_mode == true) {
        optionsData.centeredSlides = true;
      }

      if (sectionSetting.swipe_type == "mousewheel") {
        optionsData.mousewheel = true;
      } else if (sectionSetting.swipe_type == "keyboard") {
        optionsData.keyboard = true;
      }

      if (sectionSetting.enable_loop == true) {
        optionsData.loop = true;
        optionsData.rewind = true;
      }

      if (this.dataset.breakpoints) {
        const breakpoints = JSON.parse(this.dataset.breakpoints);
        for (const key in breakpoints) {
          if (key == 0) {
            optionsData.breakpoints[key] = {
              slidesPerView: breakpoints[key],
              spaceBetween: spacemobile,
            };
          } else {
            let customspaceBetween = space;
            let breakpointsKey = key;

            if (key.indexOf("m") > -1) {
              breakpointsKey = key.split("-")[1];
              customspaceBetween = spacemobile;
            }

            optionsData.breakpoints[breakpointsKey] = {
              slidesPerView: breakpoints[key],
              spaceBetween: customspaceBetween,
            };
          }
        }
      }

      if (sectionSetting.auto_rotate == true) {
        autoplay = true;
        optionsData.autoplay = {
          delay: sectionSetting.change_slides_speed * 1000,
          disableOnInteraction: false,
        };
      } else if (this.querySelector("[data-ff-source]") && sectionSetting.enable_autoplay == true) {
        autoplay = true;
        optionsData.autoplay = {
          delay: Math.max(2000, parseInt(sectionSetting.autoplay_speed, 10) || 5000),
          disableOnInteraction: false,
        };
      }


      // new add for slider animation
      const swipeEffect = sectionSetting.swipe_effect || this.dataset.swipeEffect;
      const imageRoot = this.querySelector("[data-tl-images]") || this.querySelector(".bz-tl__image-swiper");
      const canLoop = (imageRoot ? imageRoot.querySelectorAll(".swiper-slide").length : this.querySelectorAll(".swiper-slide").length) > 1;
      if (swipeEffect === "fade") {
        optionsData.effect = "fade";
        optionsData.fadeEffect = { crossFade: true };
        // if (canLoop) optionsData.loop = true;
        if (canLoop && this.dataset.loop !== "false") optionsData.loop = true;
      } else if (swipeEffect === "creative") {
        optionsData.effect = "creative";
        optionsData.creativeEffect = {
          prev: { shadow: true, translate: [0, 0, -400] },
          next: { translate: ["100%", 0, 0] },
        };
        if (canLoop) optionsData.loop = true;
      } else if (swipeEffect === "showcase") {
        this.showcaseStack = true;
        optionsData.effect = "fade";
        optionsData.fadeEffect = { crossFade: true };
        optionsData.slidesPerView = 1;
        optionsData.spaceBetween = 0;
        optionsData.speed = 700;
        optionsData.breakpoints = {
          0: { slidesPerView: 1, spaceBetween: 0 },
          768: { slidesPerView: 1, spaceBetween: 0 },
          992: { slidesPerView: 1, spaceBetween: 0 },
        };
        // if (canLoop) optionsData.loop = true;
        if (canLoop && sectionSetting.enable_loop == true) optionsData.loop = true;
      } else if (swipeEffect === "cards") {
        this.timelineStack = true;
        optionsData.virtualTranslate = true;
        optionsData.watchSlidesProgress = true;
        optionsData.grabCursor = canLoop;
        optionsData.centeredSlides = true;
        optionsData.slidesPerView = 1;
        optionsData.spaceBetween = 0;
        optionsData.resistanceRatio = 0.85;
        optionsData.speed = 650;
        optionsData.breakpoints = {
          0: { slidesPerView: 1, spaceBetween: 0 },
          768: { slidesPerView: 1, spaceBetween: 0 },
          992: { slidesPerView: 1, spaceBetween: 0 },
        };
        if (canLoop && sectionSetting.auto_rotate == true && !optionsData.loop) {
          optionsData.rewind = true;
        }
      }

      if (this.dataset.keyboard === "true") {
        optionsData.keyboard = { enabled: true };
      }

      let buttonArrow = this.querySelector(".slider_arows") ? this.querySelector(".slider_arows").getAttribute("data-button-type") : false;
      if (buttonArrow == "arrow") {
        // Every arrow set of this slider (e.g. desktop + mobile bottom), not the thumbs' or a nested slider's
        const ownArrows = (selector) => {
          const list = [...this.querySelectorAll(selector)].filter(
            (el) => el.closest("bz-slider") === this && !el.matches(".swiper-thumbs-next, .swiper-thumbs-prev") && !el.closest(".swiper-thumbs")
          );
          return list.length > 1 ? list : list[0] || null;
        };
        optionsData.navigation = {
          nextEl: ownArrows(".swiper-button-next"),
          prevEl: ownArrows(".swiper-button-prev"),
        };
      }

      if ( sectionSetting.pagination_style == "dots" || sectionSetting.pagination_style == "line" || sectionSetting.pagination_style == "counter" || sectionSetting.pagination_style == "numbers") {
        optionsData.pagination.el = this.querySelector(".swiper-pagination");
      }

      if (sectionSetting.pagination_style == "line") {
        optionsData.pagination.type = "bullets";
        optionsData.pagination.renderBullet = function (index, className) {
          return `<span class="${className}"><i></i><b></b></span>`;
        };
      }
    }
    /* THUMBNAIL SWIPER WITH BREAKPOINTS */
    let thumbSwiper = null;
    const thumbEl = this.querySelector(".swiper-thumbs");
    if (thumbEl) {
      let thumbSpace = 10;
      let thumbSpaceMobile = thumbSpace / 2;

      let thumbOptions = {
        slidesPerView: 4,
        spaceBetween: thumbSpace,
        watchSlidesProgress: true,
        navigation: {
          nextEl: this.querySelector(".swiper-thumbs-next"),
          prevEl: this.querySelector(".swiper-thumbs-prev"),
        },
        breakpoints: {
          0: {
            slidesPerView: 3,
            spaceBetween: thumbSpaceMobile,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: thumbSpace,
          },
          992: {
            slidesPerView: 5,
            spaceBetween: thumbSpace,
          },
        },
      };

      if (thumbEl.dataset.thumbBreakpoints) {
        const thumbBreakpoints = JSON.parse(
          thumbEl.dataset.thumbBreakpoints
        );

        for (const key in thumbBreakpoints) {
          let bpKey = key;
          let customSpace = thumbSpace;

          if (key.indexOf("m") > -1) {
            bpKey = key.split("-")[1];
            customSpace = thumbSpaceMobile;
          }

          thumbOptions.breakpoints[bpKey] = {
            slidesPerView: thumbBreakpoints[key],
            spaceBetween: customSpace,
          };
        }
      }

      const horizontalBreakpoints = thumbOptions.breakpoints;
      const sideThumb = thumbEl.closest(".thumb_pos_left, .thumb_pos_right");
      const sideMq = sideThumb ? window.matchMedia("(min-width: 992px)") : null;
      if (sideMq && sideMq.matches) {
        thumbOptions.direction = "vertical";
        thumbOptions.slidesPerView = "auto";
        delete thumbOptions.breakpoints;
      }

      thumbSwiper = new Swiper(thumbEl, thumbOptions);

      if (sideMq) {
        const mainEl = this.querySelector(".main_slider");
        const markThumbFade = () => {
          if (!thumbSwiper || thumbSwiper.destroyed) return;
          const vertical = sideMq.matches && thumbSwiper.params.direction === "vertical";
          const shift = thumbSwiper.translate || 0;
          const limit = thumbSwiper.maxTranslate();
          thumbEl.classList.toggle("is-fade-top", vertical && shift < -1);
          thumbEl.classList.toggle("is-fade-bottom", vertical && limit < -1 && shift > limit + 1);
        };
        thumbSwiper.on("setTranslate", markThumbFade);
        thumbSwiper.on("update", markThumbFade);
        
        const fitSideThumbs = () => {
          if (!thumbSwiper || thumbSwiper.destroyed) return;
          const vertical = sideMq.matches;
          const dir = vertical ? "vertical" : "horizontal";
          const nextH = vertical && mainEl ? mainEl.clientHeight : 0;
          if (vertical && nextH < 1) return;
          const h = vertical ? nextH + "px" : "";
          const dirChanged = thumbSwiper.params.direction !== dir;
          const prevH = parseInt(thumbEl.style.height, 10) || 0;
          if (!dirChanged && Math.abs((vertical ? nextH : 0) - prevH) < 2) return;
          if (dirChanged) {
            thumbSwiper.params.slidesPerView = vertical ? "auto" : 4;
            thumbSwiper.params.breakpoints = vertical ? {} : horizontalBreakpoints;
            thumbSwiper.changeDirection(dir, false);
          }
          thumbEl.style.height = h;
          thumbSwiper.update();
        };
        fitSideThumbs();
        sideMq.addEventListener("change", fitSideThumbs);
        if (mainEl && window.ResizeObserver) new ResizeObserver(fitSideThumbs).observe(mainEl);
        thumbEl.querySelectorAll("img").forEach((img) => {
          if (!img.complete) img.addEventListener("load", () => thumbSwiper && !thumbSwiper.destroyed && thumbSwiper.update(), { once: true });
        });
      }

      optionsData.thumbs = {
        swiper: thumbSwiper,
      };
    }

    const syncRoot = this.hasAttribute("data-slider-sync")
      ? this
      : this.closest("[data-slider-sync]");

    const syncSliderUi = (swiper, animate) => {
      if (!syncRoot || !swiper) return;
      const index = swiper.realIndex || 0;
      const imageWrap = syncRoot.querySelector("[data-tl-images]") || syncRoot.querySelector(".bz-tl__image-swiper .swiper-wrapper");
      const total = imageWrap
        ? imageWrap.querySelectorAll(":scope > .swiper-slide:not(.swiper-slide-duplicate)").length
        : (swiper.slides ? swiper.slides.length : 0);

      syncRoot.querySelectorAll(".bz-tl__stack-item[data-slider-index], .bz-ff__item[data-slider-index]").forEach((el) => {
        const isActive = Number(el.dataset.sliderIndex) === index;
        el.classList.toggle("is-active", isActive);
        el.setAttribute("aria-hidden", isActive ? "false" : "true");
        if (isActive) el.removeAttribute("inert");
        else el.setAttribute("inert", "");
      });

      syncRoot.querySelectorAll("[data-slider-goto]").forEach((node) => {
        const isActive = Number(node.dataset.sliderGoto) === index;
        node.classList.toggle("is-active", isActive);
        if (node.matches("button") || node.hasAttribute("aria-pressed")) {
          node.setAttribute("aria-pressed", isActive ? "true" : "false");
        }
      });

      const liveEl = syncRoot.querySelector("[data-slider-live]");
      if (liveEl) liveEl.textContent = index + 1 + " / " + total;

      const currentEl = syncRoot.querySelector("[data-slider-current]");
      if (currentEl) currentEl.textContent = String(index + 1);

      if (this.nodesSwiper) {
        this.nodesSwiper.slideTo(index);
      } else {
        const activeNode = syncRoot.querySelector("[data-slider-goto].is-active");
        if (animate && activeNode && activeNode.scrollIntoView && window.innerWidth < 768) {
          activeNode.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
        }
      }
    };

    if (syncRoot && !this.dataset.syncBound) {
      this.dataset.syncBound = "true";
      syncRoot.querySelectorAll("[data-slider-goto]").forEach((node) => {
        node.addEventListener("click", () => {
          const index = Number(node.dataset.sliderGoto || 0);
          if (!this.swiperInstance) return;
          if (this.swiperInstance.params.loop) this.swiperInstance.slideToLoop(index);
          else this.swiperInstance.slideTo(index);
        });
      });
      document.addEventListener("shopify:block:select", (event) => {
        if (!syncRoot.contains(event.target) || !this.swiperInstance) return;
        const indexed = event.target.closest("[data-slider-index], [data-slider-goto], [data-tl-tab], [data-ff-slide], .swiper-slide");
        if (!indexed) return;
        let index = Number(indexed.dataset.sliderIndex || indexed.dataset.sliderGoto);
        if (Number.isNaN(index) && indexed.hasAttribute("data-tl-tab")) {
          const tabs = Array.from(syncRoot.querySelectorAll("[data-tl-tab]"));
          index = tabs.indexOf(indexed);
        }
        if (Number.isNaN(index) && indexed.hasAttribute("data-ff-slide")) {
          const slides = Array.from(syncRoot.querySelectorAll("[data-ff-source] [data-ff-slide]"));
          index = slides.indexOf(indexed);
        }
        if (Number.isNaN(index) && indexed.classList.contains("swiper-slide")) {
          const slides = Array.from(this.querySelectorAll(".bz-tl__image-swiper .swiper-wrapper > .swiper-slide, [data-tl-images] > .swiper-slide"));
          index = slides.indexOf(indexed);
        }
        if (Number.isNaN(index) || index < 0) return;
        if (this.swiperInstance.params.loop) this.swiperInstance.slideToLoop(index);
        else this.swiperInstance.slideTo(index);
        if (this.swiperInstance.autoplay) this.swiperInstance.autoplay.stop();
      });
    }

    optionsData.on = {
      init: (swiper) => {
        const container = this.querySelector(".swiper-wrapper");
        const thumbWrapper = this.querySelector(".swiper-thumbs .swiper-wrapper");
        if (container) container.classList.add("swiper-loaded");
        if (thumbWrapper) thumbWrapper.classList.add("swiper-loaded");
        revealVisibleSlides(swiper);
        if (this.timelineStack) this.layoutTimelineStack(swiper);
        syncSliderUi(swiper, false);
        if (this.timelineStack) this.positionTimelineImage();
        if (this.showcaseStack) this.positionShowcaseImage();
        this.dispatchEvent(new CustomEvent("bz:slider:ready", { bubbles: true }));
      },
      setTranslate: (swiper) => {
        if (this.timelineStack) this.layoutTimelineStack(swiper);
      },
      setTransition: (swiper, duration) => {
        if (!this.timelineStack) return;
        swiper.slides.forEach((slide) => {
          slide.style.transitionDuration = duration + "ms";
        });
        clearTimeout(this._tlTransitionTimer);
        if (duration > 0) {
          this._tlTransitionTimer = setTimeout(() => {
            if (!swiper || swiper.destroyed || !swiper.animating) return;
            swiper.animating = false;
            swiper.wrapperEl.dispatchEvent(new CustomEvent("transitionend", { bubbles: true, cancelable: true }));
          }, duration);
        }
      },
      slideChange: (swiper) => {
        revealVisibleSlides(swiper);
        if (this.timelineStack) this.layoutTimelineStack(swiper);
        syncSliderUi(swiper, true);
        if (this.timelineStack) this.positionTimelineImage();
        if (this.showcaseStack) this.positionShowcaseImage();
      },
      resize: (swiper) => {
        revealVisibleSlides(swiper);
        if (this.timelineStack) this.layoutTimelineStack(swiper);
        if (this.timelineStack) this.positionTimelineImage();
        if (this.showcaseStack) this.positionShowcaseImage();
      },
    };

    function revealVisibleSlides(swiper) {
      swiper.slides.forEach((slide) =>
        slide.classList.remove("revealed")
      );

      const visibleSlides = swiper.slides.slice(
        swiper.activeIndex,
        swiper.activeIndex + swiper.params.slidesPerView
      );

      visibleSlides.forEach((slide, i) => {
        slide.style.transitionDelay = `${i * 0.15}s`;
        slide.classList.add("revealed");
      });
    }
    this.options = {
      ...defaults,
      ...optionsData,
    };

    const destroyOnDesktop = this.classList.contains("bz_slide_dest");

    const checkSwiperState = () => {
      const isDesktop = window.innerWidth >= 992;

      if (destroyOnDesktop && isDesktop) {
        this.destroySwiper();
      } else {
        this.initSwiper();
      }
    };

    checkSwiperState();
    window.addEventListener("resize", () => {
      checkSwiperState();
    });

    // new Swiper(this.querySelector(".swiper"), this.options);
  }

  
  initSwiper() {
    if (!this.swiperInstance) {
      this.swiperInstance = new Swiper(
        this.querySelector(".bz-tl__image-swiper") || this.querySelector(".swiper"),
        this.options
      );
      this.initTimelineNodesSlider();
    }
  }
  destroySwiper() {
    if (this.nodesSwiper) {
      this.nodesSwiper.destroy(true, true);
      this.nodesSwiper = null;
    }
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }
  }
  initTimelineNodesSlider() {
    const el = this.querySelector(".bz-tl__nodes-swiper");
    if (!el || this.nodesSwiper) return;
    const count = el.querySelectorAll(".swiper-slide").length;
    if (count < 1) return;
    // columns come from the section settings ("Tab text column limit"), with the
    // same breakpoints as Featured collection / Testimonials
    let points = { 0: 1.5, 768: 3.5, 992: 5 };
    try {
      if (el.dataset.tlBreakpoints) points = JSON.parse(el.dataset.tlBreakpoints);
    } catch (e) {}
    const breakpoints = {};
    Object.keys(points).forEach((width) => {
      const view = Math.min(parseFloat(points[width]) || 1, count);
      breakpoints[width] = { slidesPerView: view, allowTouchMove: count > view };
    });
    const first = breakpoints[Object.keys(breakpoints)[0]];
    this.nodesSwiper = new Swiper(el, {
      slidesPerView: first.slidesPerView,
      spaceBetween: 0,
      watchSlidesProgress: true,
      allowTouchMove: first.allowTouchMove,
      breakpoints,
    });
  }
  layoutTimelineStack(swiper) {
    if (!swiper || !swiper.slides) return;
    const rotateAmt = this.dataset.cardsRotate != null ? parseFloat(this.dataset.cardsRotate) : 4.24;
    const width = swiper.width || swiper.size || this.querySelector(".bz-tl__image-swiper")?.offsetWidth || 1;
    const shift = -(swiper.translate || 0) / (width || 1);
    swiper.slides.forEach((slide, index) => {
      if (slide.classList.contains("swiper-slide-duplicate")) {
        slide.style.opacity = "0";
        slide.style.pointerEvents = "none";
        return;
      }
      const progress = shift - index;
      const abs = Math.abs(progress);
      if (abs > 2.15) {
        slide.style.opacity = "0";
        slide.style.zIndex = "1";
        slide.style.pointerEvents = "none";
        slide.style.transform = "none";
        return;
      }
      const restRotate = index % 2 === 1 ? rotateAmt : -rotateAmt;
      const rotate = restRotate * Math.min(abs, 1);
      slide.style.opacity = "1";
      slide.style.zIndex = String(Math.round((2.15 - abs) * 20));
      slide.style.pointerEvents = abs < 0.35 ? "auto" : "none";
      slide.style.transform = rotate ? "rotate(" + rotate + "deg)" : "none";
    });
  }
  buildTimelineSource() {
    const source = this.querySelector("[data-tl-source]");
    if (!source) return;

    const imageWrapper = this.querySelector("[data-tl-images]");
    const nodesWrap = this.querySelector("[data-tl-nodes]");
    const panels = this.querySelector("[data-tl-panels]");
    if (!imageWrapper) return;

    const placeholderSlide =
      '<div class="bz-block-image bz-block-image--square" data-tl-part="image"></div>';

    // one panel per tab: holds the tab's own blocks (groups, headings ...)
    const createPanel = (index) => {
      const item = document.createElement("div");
      item.className = "bz-tl__stack-item bz-tl__panel";
      item.dataset.sliderIndex = String(index);
      if (index === 0) {
        item.classList.add("is-active");
      } else {
        item.setAttribute("inert", "");
        item.setAttribute("aria-hidden", "true");
      }
      return item;
    };

    const tabs = Array.from(source.querySelectorAll("[data-tl-tab]"));
    if (!tabs.length) {
      Array.from(this.querySelectorAll("[data-slider-goto]")).forEach((node, index) => {
        const slide = document.createElement("div");
        slide.className = "swiper-slide";
        slide.dataset.sliderIndex = String(index);
        slide.innerHTML = placeholderSlide;
        imageWrapper.appendChild(slide);
        if (panels) panels.appendChild(createPanel(index));
      });
      return;
    }

    if (nodesWrap) {
      Array.from(nodesWrap.querySelectorAll("[data-slider-goto], .bz-tl__node")).forEach((node) => node.remove());
    }

    const lineColors = [];
    tabs.forEach((tab, index) => {
      const node = tab.querySelector("[data-tl-node]");
      if (node && nodesWrap) {
        node.classList.add("swiper-slide");
        node.dataset.sliderGoto = String(index);
        node.classList.toggle("is-active", index === 0);
        node.setAttribute("aria-pressed", index === 0 ? "true" : "false");
        nodesWrap.appendChild(node);
      }
      if (tab.dataset.captionColor) lineColors.push(tab.dataset.captionColor);

      // the first image of the tab becomes a card in the image stack;
      // an invisible slot keeps its place (and size) inside the tab's group layout
      const imageSlide = document.createElement("div");
      imageSlide.className = "swiper-slide";
      imageSlide.dataset.sliderIndex = String(index);
      const image = tab.querySelector('[data-tl-part="image"]');
      if (image) {
        const slot = document.createElement("div");
        slot.className = image.className + " bz-tl__slot";
        const ratio = image.style.getPropertyValue("--img-ratio");
        if (ratio) slot.style.setProperty("--img-ratio", ratio);
        const ratioMobile = image.style.getPropertyValue("--img-ratio-m");
        if (ratioMobile) slot.style.setProperty("--img-ratio-m", ratioMobile);
        slot.setAttribute("data-tl-slot", "");
        slot.setAttribute("aria-hidden", "true");
        image.replaceWith(slot);
        imageSlide.appendChild(image);
      } else {
        imageSlide.innerHTML = placeholderSlide;
      }
      imageWrapper.appendChild(imageSlide);

      if (panels) {
        const panel = createPanel(index);
        Array.from(tab.childNodes).forEach((child) => panel.appendChild(child));
        panels.appendChild(panel);
      }
    });

    if (nodesWrap) nodesWrap.style.setProperty("--tl-count", String(tabs.length));
    this.style.setProperty("--tl-count", String(tabs.length));
    if (lineColors.length) {
      this.style.setProperty("--tl-line", "linear-gradient(90deg, " + lineColors.join(", ") + ")");
    }

    this.positionTimelineImage();
    if (panels && window.ResizeObserver && !this.tlResizeObserver) {
      this.tlResizeObserver = new ResizeObserver(() => this.positionTimelineImage());
      this.tlResizeObserver.observe(panels);
    }
    window.addEventListener("load", () => this.positionTimelineImage());
  }
  // places the image stack exactly over the image slot of the active tab
  positionTimelineImage() {
    const stage = this.querySelector(".bz-tl__stage");
    const hold = this.querySelector("[data-tl-hold]");
    if (!stage || !hold) return;
    const panelList = Array.from(this.querySelectorAll("[data-tl-panels] > .bz-tl__panel"));
    const active = panelList.find((panel) => panel.classList.contains("is-active")) || panelList[0];
    const slot = active ? active.querySelector("[data-tl-slot]") : null;

    // a tab whose layout has no image (removed or hidden) shows no image stack
    const hasContent = active && active.children.length > 0;
    hold.classList.toggle("is-hidden", !slot && !!hasContent);

    if (!slot || !slot.offsetWidth) {
      hold.classList.remove("is-anchored");
      hold.style.removeProperty("left");
      hold.style.removeProperty("top");
      hold.style.removeProperty("width");
      return;
    }

    let x = 0;
    let y = 0;
    let el = slot;
    while (el && el !== stage) {
      x += el.offsetLeft;
      y += el.offsetTop;
      el = el.offsetParent;
    }
    if (el !== stage) {
      const stageRect = stage.getBoundingClientRect();
      const slotRect = slot.getBoundingClientRect();
      x = slotRect.left - stageRect.left;
      y = slotRect.top - stageRect.top;
    }

    const width = slot.offsetWidth;
    const widthChanged = hold.style.width !== width + "px";
    hold.classList.add("is-anchored");
    hold.style.left = x + "px";
    hold.style.top = y + "px";
    hold.style.width = width + "px";

    if (widthChanged && this.swiperInstance) {
      this.swiperInstance.update();
      if (this.timelineStack) this.layoutTimelineStack(this.swiperInstance);
    }

    // the slot reserves the height of the tallest card, so the stack never overlaps the timeline
    const stackWrap = this.querySelector("[data-tl-images]");
    const stackHeight = stackWrap ? stackWrap.offsetHeight : 0;
    if (stackHeight && this.style.getPropertyValue("--tl-stack-h") !== stackHeight + "px") {
      this.style.setProperty("--tl-stack-h", stackHeight + "px");
    }
  }
  buildInfoTabSource() {
    const tabsWrap = this.querySelector("[data-it-tabs]");
    if (!tabsWrap) return;
    const slides = Array.from(this.querySelectorAll("[data-it-slide]"));
    tabsWrap.innerHTML = "";
    slides.forEach((slide, index) => {
      slide.dataset.sliderIndex = String(index);
      const node = slide.querySelector("[data-it-node]");
      if (!node) return;
      node.dataset.sliderGoto = String(index);
      node.classList.toggle("is-active", index === 0);
      node.setAttribute("aria-pressed", index === 0 ? "true" : "false");
      tabsWrap.appendChild(node);
    });
    const totalEl = this.querySelector("[data-it-total]");
    if (totalEl) totalEl.textContent = String(slides.length);
    const nav = this.querySelector("[data-it-nav]");
    if (nav) nav.hidden = slides.length < 2;
    tabsWrap.hidden = slides.length < 1;
  }
  buildShowcaseSource() {
    const source = this.querySelector("[data-ff-source]");
    if (!source) return;

    const imageWrapper = this.querySelector("[data-ff-images]");
    const panels = this.querySelector("[data-ff-panels]");
    if (!imageWrapper) return;

    // one panel per slide: holds the slide's own blocks (groups, headings ...)
    const createPanel = (index) => {
      const item = document.createElement("div");
      item.className = "bz-ff__item bz-ff__panel";
      item.dataset.sliderIndex = String(index);
      if (index === 0) {
        item.classList.add("is-active");
      } else {
        item.setAttribute("inert", "");
        item.setAttribute("aria-hidden", "true");
      }
      return item;
    };

    const slides = Array.from(source.querySelectorAll("[data-ff-slide]"));
    slides.forEach((slide, index) => {
      slide.dataset.sliderIndex = String(index);

      // the first image of the slide goes to the image swiper;
      // an invisible slot keeps its place (and size) inside the slide's group layout
      const imageSlide = document.createElement("div");
      imageSlide.className = "swiper-slide";
      imageSlide.dataset.sliderIndex = String(index);
      const image = slide.querySelector('[data-ff-part="image"]');
      if (image) {
        const slot = document.createElement("div");
        slot.className = image.className + " bz-ff__slot";
        const ratio = image.style.getPropertyValue("--img-ratio");
        if (ratio) slot.style.setProperty("--img-ratio", ratio);
        const ratioMobile = image.style.getPropertyValue("--img-ratio-m");
        if (ratioMobile) slot.style.setProperty("--img-ratio-m", ratioMobile);
        slot.setAttribute("data-ff-slot", "");
        slot.setAttribute("aria-hidden", "true");
        image.replaceWith(slot);
        imageSlide.appendChild(image);
      }
      imageWrapper.appendChild(imageSlide);

      if (panels) {
        const panel = createPanel(index);
        Array.from(slide.childNodes).forEach((child) => panel.appendChild(child));
        panels.appendChild(panel);
      }
    });

    const firstImage = imageWrapper.querySelector("img");
    if (firstImage) {
      firstImage.loading = "eager";
      firstImage.fetchPriority = "high";
    }

    this.positionShowcaseImage();
    if (panels && window.ResizeObserver && !this.ffResizeObserver) {
      this.ffResizeObserver = new ResizeObserver(() => this.positionShowcaseImage());
      this.ffResizeObserver.observe(panels);
    }
    window.addEventListener("load", () => this.positionShowcaseImage());

    // text panels sit outside the swiper, so a drag on the stage is bridged to it
    const stage = this.querySelector(".bz-ff__stage");
    if (stage && !stage.dataset.ffDrag) {
      stage.dataset.ffDrag = "1";
      let sx = 0;
      let sy = 0;
      let dragging = false;

      stage.addEventListener("pointerdown", (event) => {
        if (event.button > 0) return;
        if (event.target.closest("a, button, input, select, textarea, .swiper, [data-slider-goto]")) return;
        dragging = true;
        sx = event.clientX;
        sy = event.clientY;
      }, { passive: true });

      stage.addEventListener("pointerup", (event) => {
        if (!dragging) return;
        dragging = false;
        const dx = event.clientX - sx;
        if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(event.clientY - sy)) return;
        if (!this.swiperInstance) return;
        if (dx < 0) this.swiperInstance.slideNext();
        else this.swiperInstance.slidePrev();
      }, { passive: true });
    }
  }
  // places the image swiper exactly over the image slot of the active slide
  positionShowcaseImage() {
    const stage = this.querySelector(".bz-ff__stage");
    const hold = this.querySelector("[data-ff-hold]");
    if (!stage || !hold) return;
    const panelList = Array.from(this.querySelectorAll("[data-ff-panels] > .bz-ff__panel"));
    const active = panelList.find((panel) => panel.classList.contains("is-active")) || panelList[0];
    const slot = active ? active.querySelector("[data-ff-slot]") : null;

    const hasContent = active && active.children.length > 0;
    hold.classList.toggle("is-hidden", !slot && !!hasContent);

    if (!slot || !slot.offsetWidth) {
      hold.classList.remove("is-anchored");
      hold.style.removeProperty("left");
      hold.style.removeProperty("top");
      hold.style.removeProperty("width");
      return;
    }

    let x = 0;
    let y = 0;
    let el = slot;
    while (el && el !== stage) {
      x += el.offsetLeft;
      y += el.offsetTop;
      el = el.offsetParent;
    }
    if (el !== stage) {
      const stageRect = stage.getBoundingClientRect();
      const slotRect = slot.getBoundingClientRect();
      x = slotRect.left - stageRect.left;
      y = slotRect.top - stageRect.top;
    }

    const width = slot.offsetWidth;
    const widthChanged = hold.style.width !== width + "px";
    hold.classList.add("is-anchored");
    hold.style.left = x + "px";
    hold.style.top = y + "px";
    hold.style.width = width + "px";

    if (widthChanged && this.swiperInstance) this.swiperInstance.update();

    // the slot reserves the height of the tallest image, so nothing overlaps
    const stackWrap = this.querySelector("[data-ff-images]");
    const stackHeight = stackWrap ? stackWrap.offsetHeight : 0;
    if (stackHeight && this.style.getPropertyValue("--ff-stack-h") !== stackHeight + "px") {
      this.style.setProperty("--ff-stack-h", stackHeight + "px");
    }
  }
  connectedCallback() {}
}
customElements.define("bz-slider", BzSlider);

// if (!customElements.get("bz-marquee")) {
//   customElements.define(
//     "bz-marquee",
//     class BzMarquee extends HTMLElement {
//       connectedCallback() {
//         this.track = this.querySelector("[data-sb-track]");
//         this.source = this.querySelector("[data-sb-group]");
//         if (!this.track || !this.source) return;

//         this.NS = "http://www.w3.org/2000/svg";
//         this.XLINK = "http://www.w3.org/1999/xlink";
//         this.isWave = this.dataset.style === "wave";
//         this.reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
//         this.paused = false;
//         this.visible = true;
//         this.offset = 0;
//         this.cycle = 0;
//         this.lastTs = 0;
//         this.lastWidth = 0;
//         this.uid = this.dataset.uid || String(Math.floor(Math.random() * 100000));

//         this.onEnter = () => {
//           if (this.dataset.pauseHover === "true") this.paused = true;
//         };
//         this.onLeave = () => {
//           this.paused = false;
//         };
//         if (this.isWave) {
//           this.addEventListener("mouseenter", this.onEnter);
//           this.addEventListener("mouseleave", this.onLeave);
//         }

//         this.build();

//         if ("ResizeObserver" in window) {
//           this.observer = new ResizeObserver(() => this.build());
//           this.observer.observe(this);
//         }

//         if (this.isWave && "IntersectionObserver" in window) {
//           this.io = new IntersectionObserver((entries) => {
//             this.visible = entries[0] && entries[0].isIntersecting;
//           }, { threshold: 0 });
//           this.io.observe(this);
//         }

//         if (this.isWave) this.raf = requestAnimationFrame((ts) => this.tick(ts));
//       }

//       disconnectedCallback() {
//         if (this.raf) cancelAnimationFrame(this.raf);
//         if (this.observer) this.observer.disconnect();
//         if (this.io) this.io.disconnect();
//         this.removeEventListener("mouseenter", this.onEnter);
//         this.removeEventListener("mouseleave", this.onLeave);
//       }

//       build() {
//         if (this.isWave) this.buildWave();
//         else this.fillTrack();
//       }

//       cloneGroup(node) {
//         const clone = node.cloneNode(true);
//         clone.setAttribute("aria-hidden", "true");
//         clone.querySelectorAll("[id]").forEach((el) => el.removeAttribute("id"));
//         return clone;
//       }

//       fillTrack() {
//         const viewport = this.clientWidth || 0;
//         if (viewport < 1) return;
//         if (this.lastWidth && Math.abs(this.lastWidth - viewport) < 2 && this.track.children.length > 1) return;
//         this.lastWidth = viewport;

//         Array.from(this.track.querySelectorAll("[data-sb-group]")).forEach((group, index) => {
//           if (index > 0) group.remove();
//         });
//         const first = this.track.querySelector("[data-sb-group]");
//         if (!first) return;

//         let copies = 1;
//         while (this.track.scrollWidth < viewport && copies < 8) {
//           this.track.appendChild(this.cloneGroup(first));
//           copies += 1;
//         }
//         Array.from(this.track.children).forEach((node) => this.track.appendChild(this.cloneGroup(node)));
//       }

//       applyCase(text, textCase) {
//         if (textCase === "uppercase") return text.toUpperCase();
//         if (textCase === "capitalize") {
//           return text.replace(/(^|\s)(\S)/g, (lead, space, ch) => space + ch.toUpperCase());
//         }
//         return text;
//       }

//       segmentsFromSource() {
//         return Array.from(this.source.querySelectorAll(".bz-sb__text, .bz-sb__sep"))
//           .map((el) => {
//             const text = el.textContent.replace(/\s+/g, " ").trim();
//             if (!text) return null;
//             const isText = el.classList.contains("bz-sb__text");
//             let textCase = "none";
//             if (isText) {
//               if (el.dataset.case === "uppercase" || el.dataset.case === "capitalize") {
//                 textCase = el.dataset.case;
//               } else if (el.classList.contains("upcase") || el.classList.contains("is-upper")) {
//                 textCase = "uppercase";
//               } else {
//                 textCase = "capitalize";
//               }
//             }
//             return {
//               text: text + " ",
//               outline: isText && (el.dataset.outline === "true" || el.classList.contains("is-outline")),
//               textCase: textCase,
//             };
//           })
//           .filter(Boolean);
//       }

//       waveTextColor() {
//         const value = getComputedStyle(this).getPropertyValue("--wave-text").trim();
//         return value || "#fff";
//       }

//       parseGradientStops(value) {
//         const raw = (value || "").trim();
//         const fallback = [
//           { offset: "0%", color: "#F07828" },
//           { offset: "100%", color: "#0E5CB3" },
//         ];
//         if (!raw) return fallback;
//         if (raw.indexOf("gradient") === -1) {
//           return [
//             { offset: "0%", color: raw },
//             { offset: "100%", color: raw },
//           ];
//         }

//         const matchGrad = raw.match(/linear-gradient\((?:[^()]|\([^()]*\))*\)/i);
//         const gradient = matchGrad ? matchGrad[0] : raw;
//         const inner = gradient.replace(/^linear-gradient\(/i, "").replace(/\)$/, "");
//         const parts = [];
//         let buf = "";
//         let depth = 0;
//         for (let i = 0; i < inner.length; i++) {
//           const ch = inner[i];
//           if (ch === "(") depth += 1;
//           if (ch === ")") depth -= 1;
//           if (ch === "," && depth === 0) {
//             parts.push(buf.trim());
//             buf = "";
//           } else {
//             buf += ch;
//           }
//         }
//         if (buf.trim()) parts.push(buf.trim());

//         const stops = [];
//         parts.forEach((part) => {
//           if (/^(to\s|[\d.+-]+(deg|rad|turn|grad))$/i.test(part)) return;
//           const withPos = part.match(/^(.*?)\s+(-?[\d.]+%)\s*$/);
//           if (withPos) stops.push({ color: withPos[1].trim(), offset: withPos[2] });
//           else if (part) stops.push({ color: part, offset: null });
//         });
//         stops.forEach((stop, index) => {
//           if (stop.offset) {
//             const num = parseFloat(stop.offset);
//             if (num > 100) stop.offset = "100%";
//             if (num < 0) stop.offset = "0%";
//             return;
//           }
//           stop.offset = stops.length === 1 ? "0%" : ((index / (stops.length - 1)) * 100).toFixed(2) + "%";
//         });
//         return stops.length ? stops : fallback;
//       }

//       sinePath(width, cy, wavelength, amp, periods) {
//         const k = amp * 1.35;
//         let d = "M0 " + cy.toFixed(2);
//         for (let i = 0; i < periods; i++) {
//           const x0 = i * wavelength;
//           const x1 = x0 + wavelength * 0.25;
//           const x2 = x0 + wavelength * 0.5;
//           const x3 = x0 + wavelength * 0.75;
//           const x4 = x0 + wavelength;
//           d += " C" + x1.toFixed(2) + " " + (cy - k).toFixed(2) + ", " + x1.toFixed(2) + " " + (cy - k).toFixed(2) + ", " + x2.toFixed(2) + " " + cy.toFixed(2);
//           d += " C" + x3.toFixed(2) + " " + (cy + k).toFixed(2) + ", " + x3.toFixed(2) + " " + (cy + k).toFixed(2) + ", " + x4.toFixed(2) + " " + cy.toFixed(2);
//         }
//         return d;
//       }

//       buildWave() {
//         const width = this.clientWidth || 0;
//         if (width < 1) return;
//         if (this.lastWidth && Math.abs(this.lastWidth - width) < 2 && this.textPath) return;
//         this.lastWidth = width;

//         const segments = this.segmentsFromSource();
//         this.querySelectorAll("svg").forEach((svg) => svg.remove());
//         if (!segments.length) return;

//         const amp = Math.max(8, parseInt(this.dataset.amp, 10) || 28);
//         const wavesSetting = Math.max(2, parseInt(this.dataset.waves, 10) || 2);
//         const baseSize = Math.max(12, parseInt(this.dataset.fontSize, 10) || 16);
//         let waves = wavesSetting;
//         let fontSize = baseSize;
//         let waveAmp = amp;
//         if (width <= 991) {
//           const isPhone = width <= 767;
//           fontSize = Math.max(13, Math.round(baseSize * (isPhone ? 0.62 : 0.8)));
//           waveAmp = Math.max(8, Math.round(amp * (isPhone ? 0.6 : 0.78)));
//           const minWave = isPhone ? 220 : 280;
//           waves = Math.max(1, Math.min(wavesSetting, width / minWave));
//         }
//         const speed = Math.max(5, parseInt(this.dataset.speed, 10) || 20);
//         const stroke = Math.max(fontSize * 2.2, 36);
//         const height = Math.ceil(stroke + waveAmp * 2 + 8);
//         const cy = height / 2;
//         const wavelength = width / waves;
//         const periods = Math.ceil(waves * 3);
//         const pathWidth = wavelength * periods;
//         const pathId = "bz-wave-path-" + this.uid;
//         const gradId = "bz-wave-grad-" + this.uid;
//         const d = this.sinePath(pathWidth, cy, wavelength, waveAmp, periods);
//         const stops = this.parseGradientStops(getComputedStyle(this).getPropertyValue("--wave-gradient"));

//         const svg = document.createElementNS(this.NS, "svg");
//         svg.setAttribute("viewBox", "0 0 " + width + " " + height);
//         svg.setAttribute("width", "100%");
//         svg.setAttribute("height", String(height));
//         svg.setAttribute("preserveAspectRatio", "none");
//         svg.setAttribute("aria-hidden", "true");
//         svg.setAttribute("focusable", "false");

//         const defs = document.createElementNS(this.NS, "defs");
//         const grad = document.createElementNS(this.NS, "linearGradient");
//         grad.setAttribute("id", gradId);
//         grad.setAttribute("gradientUnits", "userSpaceOnUse");
//         grad.setAttribute("x1", "0");
//         grad.setAttribute("y1", "0");
//         grad.setAttribute("x2", String(width));
//         grad.setAttribute("y2", "0");
//         stops.forEach((stop) => {
//           const el = document.createElementNS(this.NS, "stop");
//           el.setAttribute("offset", stop.offset);
//           el.setAttribute("stop-color", stop.color);
//           grad.appendChild(el);
//         });

//         const pathDef = document.createElementNS(this.NS, "path");
//         pathDef.setAttribute("id", pathId);
//         pathDef.setAttribute("d", d);
//         pathDef.setAttribute("fill", "none");
//         defs.appendChild(grad);
//         defs.appendChild(pathDef);

//         const ribbon = document.createElementNS(this.NS, "use");
//         ribbon.setAttribute("href", "#" + pathId);
//         ribbon.setAttributeNS(this.XLINK, "href", "#" + pathId);
//         ribbon.setAttribute("fill", "none");
//         ribbon.setAttribute("stroke", "url(#" + gradId + ")");
//         ribbon.setAttribute("stroke-width", String(stroke));
//         ribbon.setAttribute("stroke-linejoin", "round");
//         ribbon.setAttribute("stroke-linecap", "butt");

//         const text = document.createElementNS(this.NS, "text");
//         text.setAttribute("dy", String(Math.round(fontSize * 0.35)));
//         text.style.fontSize = fontSize + "px";

//         const textPath = document.createElementNS(this.NS, "textPath");
//         textPath.setAttribute("href", "#" + pathId);
//         textPath.setAttributeNS(this.XLINK, "href", "#" + pathId);
//         textPath.setAttribute("startOffset", "0");
//         text.appendChild(textPath);

//         svg.appendChild(defs);
//         svg.appendChild(ribbon);
//         svg.appendChild(text);
//         this.appendChild(svg);

//         this.path = pathDef;
//         this.textPath = textPath;
//         this.speed = speed;
//         this.fontSize = fontSize;
//         this.segments = segments;
//         this.fillText();
//         if (document.fonts && document.fonts.ready) {
//           document.fonts.ready.then(() => this.fillText());
//         }
//       }

//       appendCycle(color, strokeWidth) {
//         this.segments.forEach((seg) => {
//           const tspan = document.createElementNS(this.NS, "tspan");
//           tspan.textContent = this.applyCase(seg.text, seg.textCase);
//           if (seg.outline) {
//             tspan.style.fill = "none";
//             tspan.style.stroke = color;
//             tspan.style.strokeWidth = strokeWidth + "px";
//             tspan.style.paintOrder = "stroke";
//           } else {
//             tspan.style.fill = color;
//             tspan.style.stroke = "none";
//           }
//           this.textPath.appendChild(tspan);
//         });
//       }

//       fillText() {
//         if (!this.textPath || !this.path || !this.segments || !this.segments.length) return;
//         const color = this.waveTextColor();
//         const fontSize = this.fontSize || 24;
//         const strokeWidth = Math.max(1.2, fontSize * 0.05);
//         this.textPath.textContent = "";
//         this.appendCycle(color, strokeWidth);
//         const cycle = this.textPath.getComputedTextLength();
//         if (!cycle) return;
//         this.cycle = cycle;
//         const pathLen = this.path.getTotalLength();
//         let copies = Math.max(2, Math.ceil((pathLen + cycle) / cycle) + 1);
//         if (copies > 24) copies = 24;
//         this.textPath.textContent = "";
//         for (let i = 0; i < copies; i++) this.appendCycle(color, strokeWidth);
//         if (this.offset) this.textPath.setAttribute("startOffset", String(-this.offset));
//       }

//       tick(ts) {
//         this.raf = requestAnimationFrame((next) => this.tick(next));
//         if (!this.lastTs) this.lastTs = ts;
//         const delta = Math.min(48, ts - this.lastTs);
//         this.lastTs = ts;
//         if (!this.textPath || !this.cycle || this.reduceMotion || !this.visible || this.paused) return;
//         this.offset = (this.offset + (this.cycle / (this.speed * 1000)) * delta) % this.cycle;
//         this.textPath.setAttribute("startOffset", String(-this.offset));
//       }
//     }
//   );
// }

if (!customElements.get("bz-marquee")) {
  const SVG_NS = "http://www.w3.org/2000/svg";
  const attr = (value) => String(value).replace(/&/g, "&amp;").replace(/"/g, "&quot;");

  customElements.define("bz-marquee", class BzMarquee extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector("[data-sb-track]");
      this.source = this.querySelector("[data-sb-group]");
      if (!this.track || !this.source) return;

      this.isWave = this.dataset.style === "wave";
      this.reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      this.paused = false;
      this.visible = true;
      this.offset = 0;
      this.cycle = 0;
      this.lastTs = 0;
      this.lastWidth = 0;
      this.uid = this.dataset.uid || String(Math.floor(Math.random() * 100000));
      this.onEnter = () => { if (this.dataset.pauseHover === "true") this.paused = true; };
      this.onLeave = () => { this.paused = false; };
      if (this.isWave) {
        this.addEventListener("mouseenter", this.onEnter);
        this.addEventListener("mouseleave", this.onLeave);
      }
      this.build();
      if ("ResizeObserver" in window) {
        this.observer = new ResizeObserver(() => this.build());
        this.observer.observe(this);
      }
      if (this.isWave && "IntersectionObserver" in window) {
        this.io = new IntersectionObserver((entries) => {
          this.visible = entries[0] && entries[0].isIntersecting;
        }, { threshold: 0 });
        this.io.observe(this);
      }
      if (this.isWave) this.raf = requestAnimationFrame((ts) => this.tick(ts));
    }

    disconnectedCallback() {
      if (this.raf) cancelAnimationFrame(this.raf);
      if (this.observer) this.observer.disconnect();
      if (this.io) this.io.disconnect();
      this.removeEventListener("mouseenter", this.onEnter);
      this.removeEventListener("mouseleave", this.onLeave);
    }

    build() {
      if (this.isWave) this.buildWave();
      else this.fillTrack();
    }

    cloneGroup(node) {
      const clone = node.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      clone.querySelectorAll("[id]").forEach((el) => el.removeAttribute("id"));
      // Visual duplicate only: keep its links / buttons out of the Tab order
      [clone, ...clone.querySelectorAll("a[href], button, input, select, textarea, [tabindex]")]
        .filter((el) => el.matches("a[href], button, input, select, textarea, [tabindex]"))
        .forEach((el) => el.setAttribute("tabindex", "-1"));
      return clone;
    }

    fillTrack() {
      const viewport = this.clientWidth || 0;
      if (viewport < 1) return;
      if (this.lastWidth && Math.abs(this.lastWidth - viewport) < 2 && this.track.children.length > 1) return;
      this.lastWidth = viewport;
      Array.from(this.track.querySelectorAll("[data-sb-group]")).forEach((group, index) => {
        if (index > 0) group.remove();
      });
      const first = this.track.querySelector("[data-sb-group]");
      if (!first) return;
      let copies = 1;
      while (this.track.scrollWidth < viewport && copies < 8) {
        this.track.appendChild(this.cloneGroup(first));
        copies += 1;
      }
      Array.from(this.track.children).forEach((node) => this.track.appendChild(this.cloneGroup(node)));
    }

    applyCase(text, textCase) {
      if (textCase === "uppercase") return text.toUpperCase();
      if (textCase === "capitalize") return text.replace(/(^|\s)(\S)/g, (lead, space, ch) => space + ch.toUpperCase());
      return text;
    }

    segmentsFromSource() {
      return Array.from(this.source.querySelectorAll(".bz-sb__text, .bz-sb__sep")).map((el) => {
        const text = el.textContent.replace(/\s+/g, " ").trim();
        if (!text) return null;
        const isText = el.classList.contains("bz-sb__text");
        let textCase = "none";
        if (isText) {
          if (el.dataset.case === "uppercase" || el.dataset.case === "capitalize") textCase = el.dataset.case;
          else if (el.classList.contains("upcase") || el.classList.contains("is-upper")) textCase = "uppercase";
          else textCase = "capitalize";
        }
        return {
          text: text + " ",
          outline: isText && (el.dataset.outline === "true" || el.classList.contains("is-outline")),
          textCase: textCase
        };
      }).filter(Boolean);
    }

    waveTextColor() {
      return getComputedStyle(this).getPropertyValue("--wave-text").trim() || "#fff";
    }

    parseGradientStops(value) {
      const raw = (value || "").trim();
      const fallback = [{ offset: "0%", color: "#F07828" }, { offset: "100%", color: "#0E5CB3" }];
      if (!raw) return fallback;
      if (raw.indexOf("gradient") === -1) return [{ offset: "0%", color: raw }, { offset: "100%", color: raw }];

      const matchGrad = raw.match(/linear-gradient\((?:[^()]|\([^()]*\))*\)/i);
      const inner = (matchGrad ? matchGrad[0] : raw).replace(/^linear-gradient\(/i, "").replace(/\)$/, "");
      const parts = [];
      let buf = "";
      let depth = 0;
      for (let i = 0; i < inner.length; i++) {
        const ch = inner[i];
        if (ch === "(") depth += 1;
        if (ch === ")") depth -= 1;
        if (ch === "," && depth === 0) {
          parts.push(buf.trim());
          buf = "";
        } else buf += ch;
      }
      if (buf.trim()) parts.push(buf.trim());

      const stops = [];
      parts.forEach((part) => {
        if (/^(to\s|[\d.+-]+(deg|rad|turn|grad))$/i.test(part)) return;
        const withPos = part.match(/^(.*?)\s+(-?[\d.]+%)\s*$/);
        if (withPos) stops.push({ color: withPos[1].trim(), offset: withPos[2] });
        else if (part) stops.push({ color: part, offset: null });
      });
      stops.forEach((stop, index) => {
        if (stop.offset) {
          const num = parseFloat(stop.offset);
          if (num > 100) stop.offset = "100%";
          if (num < 0) stop.offset = "0%";
          return;
        }
        stop.offset = stops.length === 1 ? "0%" : ((index / (stops.length - 1)) * 100).toFixed(2) + "%";
      });
      return stops.length ? stops : fallback;
    }

    sinePath(cy, wavelength, amp, periods) {
      const k = amp * 1.35;
      const n = (value) => value.toFixed(2);
      let d = "M0 " + n(cy);
      for (let i = 0; i < periods; i++) {
        const x = i * wavelength;
        d += " C" + n(x + wavelength * 0.25) + " " + n(cy - k) + ", " + n(x + wavelength * 0.25) + " " + n(cy - k) + ", " + n(x + wavelength * 0.5) + " " + n(cy);
        d += " C" + n(x + wavelength * 0.75) + " " + n(cy + k) + ", " + n(x + wavelength * 0.75) + " " + n(cy + k) + ", " + n(x + wavelength) + " " + n(cy);
      }
      return d;
    }

    buildWave() {
      const width = this.clientWidth || 0;
      if (width < 1) return;
      if (this.lastWidth && Math.abs(this.lastWidth - width) < 2 && this.textPath) return;
      this.lastWidth = width;

      const segments = this.segmentsFromSource();
      this.querySelectorAll("svg").forEach((svg) => svg.remove());
      if (!segments.length) return;

      const amp = Math.max(8, parseInt(this.dataset.amp, 10) || 28);
      const wavesSetting = Math.max(2, parseInt(this.dataset.waves, 10) || 2);
      const baseSize = Math.max(12, parseInt(this.dataset.fontSize, 10) || 16);
      let waves = wavesSetting;
      let fontSize = baseSize;
      let waveAmp = amp;
      if (width <= 991) {
        const isPhone = width <= 767;
        fontSize = Math.max(13, Math.round(baseSize * (isPhone ? 0.62 : 0.8)));
        waveAmp = Math.max(8, Math.round(amp * (isPhone ? 0.6 : 0.78)));
        waves = Math.max(1, Math.min(wavesSetting, width / (isPhone ? 220 : 280)));
      }
      const stroke = Math.max(fontSize * 2.2, 36);
      const height = Math.ceil(stroke + waveAmp * 2 + 8);
      const wavelength = width / waves;
      const periods = Math.ceil(waves * 3);
      const pathId = "bz-wave-path-" + this.uid;
      const gradId = "bz-wave-grad-" + this.uid;
      const stops = this.parseGradientStops(getComputedStyle(this).getPropertyValue("--wave-gradient"));
      const svg = document.createElementNS(SVG_NS, "svg");
      svg.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink");
      svg.setAttribute("viewBox", "0 0 " + width + " " + height);
      svg.setAttribute("width", "100%");
      svg.setAttribute("height", String(height));
      svg.setAttribute("preserveAspectRatio", "none");
      svg.setAttribute("aria-hidden", "true");
      svg.setAttribute("focusable", "false");
      svg.innerHTML = "<defs><linearGradient id=\"" + gradId + "\" gradientUnits=\"userSpaceOnUse\" x1=\"0\" y1=\"0\" x2=\"" + width + "\" y2=\"0\">" +
        stops.map((stop) => "<stop offset=\"" + attr(stop.offset) + "\" stop-color=\"" + attr(stop.color) + "\"></stop>").join("") +
        "</linearGradient><path id=\"" + pathId + "\" d=\"" + attr(this.sinePath(height / 2, wavelength, waveAmp, periods)) + "\" fill=\"none\"></path></defs>" +
        "<use href=\"#" + pathId + "\" xlink:href=\"#" + pathId + "\" fill=\"none\" stroke=\"url(#" + gradId + ")\" stroke-width=\"" + stroke + "\" stroke-linejoin=\"round\" stroke-linecap=\"butt\"></use>" +
        "<text dy=\"" + Math.round(fontSize * 0.35) + "\" style=\"font-size:" + fontSize + "px\"><textPath href=\"#" + pathId + "\" xlink:href=\"#" + pathId + "\" startOffset=\"0\"></textPath></text>";
      this.appendChild(svg);

      this.path = svg.querySelector("path");
      this.textPath = svg.querySelector("textPath");
      this.speed = Math.max(5, parseInt(this.dataset.speed, 10) || 20);
      this.fontSize = fontSize;
      this.segments = segments;
      this.fillText();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.fillText());
    }

    appendCycle(color, strokeWidth) {
      this.segments.forEach((seg) => {
        const tspan = document.createElementNS(SVG_NS, "tspan");
        tspan.textContent = this.applyCase(seg.text, seg.textCase);
        if (seg.outline) {
          tspan.style.fill = "none";
          tspan.style.stroke = color;
          tspan.style.strokeWidth = strokeWidth + "px";
          tspan.style.paintOrder = "stroke";
        } else {
          tspan.style.fill = color;
          tspan.style.stroke = "none";
        }
        this.textPath.appendChild(tspan);
      });
    }

    fillText() {
      if (!this.textPath || !this.path || !this.segments || !this.segments.length) return;
      const color = this.waveTextColor();
      const strokeWidth = Math.max(1.2, (this.fontSize || 24) * 0.05);
      this.textPath.textContent = "";
      this.appendCycle(color, strokeWidth);
      const cycle = this.textPath.getComputedTextLength();
      if (!cycle) return;
      this.cycle = cycle;
      let copies = Math.max(2, Math.ceil((this.path.getTotalLength() + cycle) / cycle) + 1);
      if (copies > 24) copies = 24;
      this.textPath.textContent = "";
      for (let i = 0; i < copies; i++) this.appendCycle(color, strokeWidth);
      if (this.offset) this.textPath.setAttribute("startOffset", String(-this.offset));
    }

    tick(ts) {
      this.raf = requestAnimationFrame((next) => this.tick(next));
      if (!this.lastTs) this.lastTs = ts;
      const delta = Math.min(48, ts - this.lastTs);
      this.lastTs = ts;
      if (!this.textPath || !this.cycle || this.reduceMotion || !this.visible || this.paused) return;
      this.offset = (this.offset + (this.cycle / (this.speed * 1000)) * delta) % this.cycle;
      this.textPath.setAttribute("startOffset", String(-this.offset));
    }
  });
}